/**
 * @generated SignedSource<<63ebcd8fd292d1e29fa9697f1856c053>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveAttachmentsMutationInput = {
  clientMutationId?: string | null;
  ids: ReadonlyArray<string>;
};
export type PostDraftTwitterRemoveMutation$variables = {
  input: RemoveAttachmentsMutationInput;
};
export type PostDraftTwitterRemoveMutation$data = {
  readonly removeAttachments: {
    readonly __typename: "Attachments";
    readonly attachments: ReadonlyArray<{
      readonly id: string;
    }>;
  } | {
    readonly __typename: "RemoveAttachmentsError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type PostDraftTwitterRemoveMutation = {
  response: PostDraftTwitterRemoveMutation$data;
  variables: PostDraftTwitterRemoveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "removeAttachments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Attachment",
            "kind": "LinkedField",
            "name": "attachments",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "Attachments",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "RemoveAttachmentsError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostDraftTwitterRemoveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostDraftTwitterRemoveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b4ca5648ea64b2e2bb1d7e691c485ce1",
    "id": null,
    "metadata": {},
    "name": "PostDraftTwitterRemoveMutation",
    "operationKind": "mutation",
    "text": "mutation PostDraftTwitterRemoveMutation(\n  $input: RemoveAttachmentsMutationInput!\n) {\n  removeAttachments(input: $input) {\n    __typename\n    ... on Attachments {\n      attachments {\n        id\n      }\n    }\n    ... on RemoveAttachmentsError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "036d7f43e69bf1de7a87f85497678772";

export default node;
